<template>
  <el-upload
    ref="elUpload"
    action=""
    :limit="1"
    style="display: none;"
    accept=".xls,.xlsx"
    :show-file-list="false"
    :http-request="handleHttpRequest">
    <i ref="upload"></i>
  </el-upload>
</template>

<script>
export default {
  name: 'UploadNew',
  props: {
    callback: Function,
    action: {
      type: String,
      default: 'account/uploadfile'
    }
  },
  data() {
    return {
      options: {}
    }
  },
  methods: {
    handleHttpRequest(file) {
      const formData = new FormData()
      formData.append('file', file.file)
      for (const key in this.options) {
        formData.append(key, this.options[key])
      }
      this.loading = true
      this.$store.dispatch(this.action, {
        payload: formData,
        success: (res) => {
          this.loading = false
          this.$message.success('上传成功')
          this.$refs.elUpload.clearFiles()
          this.callback && this.callback(this.options, res.data)
        },
        fail: () => {
          this.$refs.elUpload.clearFiles()
          this.loading = false
        }
      })
    },
    upload(row = {}) {
      this.options = row
      this.$refs.upload.click()
    }
  }
}
</script>

<style>

</style>
